module.exports = __webpack_public_path__ + "img/waaarp_logo_bk.f30db7bb.png";